import { Collapse } from 'react-bootstrap'
import style from './index.module.scss'
import { FormattedMessage } from 'react-intl'
import { useExpand } from '../../../hooks/useExpand'
import { PropsWithChildren } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    uniqueID: string
    ariaID: string
    showHideKeys?: [string, string]
    className?: string
}

export function CustomToggle(props: PropsWithChildren<Props>) {
    const {
        children,
        uniqueID,
        ariaID,
        showHideKeys,
        className = '',
        ...rest
    } = props

    const { expanded, toggle, expandBtn } = useExpand({
        isExpanded: false,
        uniqueID,
        ariaID,
        className: `${className} ms-2 btn-clean`,
    })

    return (
        <div {...rest}>
            <Collapse in={expanded}>
                <div id={uniqueID}>{children}</div>
            </Collapse>
            <div className={style.collapse}>
                <span
                    onClick={toggle}
                    className={style.showInfo}
                    aria-expanded={expanded}
                    aria-controls={uniqueID}
                >
                    {expanded ? (
                        <FormattedMessage
                            id={
                                showHideKeys?.[1]
                                    ? showHideKeys[1]
                                    : 'buttons.hide'
                            }
                        />
                    ) : (
                        <FormattedMessage
                            id={
                                showHideKeys?.[0]
                                    ? showHideKeys[0]
                                    : 'buttons.show'
                            }
                        />
                    )}
                    {expandBtn}
                </span>
            </div>
        </div>
    )
}
